import { datadogRum } from "@datadog/browser-rum";
import { getSourceAmplifyConfigFromEndpoint } from "data/store/EnvConfig";

const initDatadog = () => {
  getSourceAmplifyConfigFromEndpoint().then(
    ({ datadogAppId, datadogClientToken, environment }) => {
      datadogRum.init({
        applicationId: datadogAppId,
        clientToken: datadogClientToken,
        site: "datadoghq.com",
        service: `research-central-${environment}`,
        env: environment,
        // Specify a version number to identify the deployed version of your application in Datadog
        // version: '1.0.0',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: "mask-user-input",
      });
    },
  );
};

export { initDatadog };
